import type { CampaignType, List, Talent } from "@/shared/types"
import { getRosterList } from "@/utils/roster"

/** My Roster (if userId), All, then system lists. Skip Brand lists for Song campaigns and music lists otherwise. */
export function buildListSwitcherOptions(args: {
    userId?: string
    rawTalent: Talent[]
    systemLists: List[]
    campaignType: CampaignType
}): List[] {
    const next: List[] = []
    if (args.userId) {
        next.push(getRosterList(args.userId, args.rawTalent))
    }
    next.push({ id: "", name: "All", active: true })
    for (const list of args.systemLists) {
        const name = list.name?.toLowerCase() || ""
        if (args.campaignType === "Song" ? name.includes("brand") : name.includes("music")) {
            continue
        }
        // System lists are browse buckets and must not lock campaign platform.
        const systemList = { ...list }
        delete systemList.platform // in practice, never exists on system lists, but just in case
        next.push(systemList)
    }
    return next
}
